import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { cmes, formatoMonto, formatMoneda } from "../../util/varios";
import { Dimmer } from "../spinner";
import ModalActuUte from "./modalActualizarPorcentaje";
import { Mensaje } from "../mensajes";
import { ToastsGeneral } from "../toasts";

const headCells = [
  {
    id: "codigo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "AÑO",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "MES",
    textAlign: "center",
  },
  {
    id: "rif",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "FECHA",
    textAlign: "center",
  },
  {
    id: "nrolicencia",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "VALOR",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaUTE() {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [contar3, setContar3] = useState(0);
  const [contar4, setContar4] = useState(0);
  const [contar5, setContar5] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuarioH, setUsuarioH] = useState();
  const [persona, setPersona] = useState();
  const [organizacion, setOrganizacion] = useState();
  const [configCome, setConfigCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [permiso, setPermiso] = useState();
  const [ute, setUte] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accporcenute = JSON.parse(localStorage.getItem("accporcenute"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.anio.includes(target.value) ||
              cmes(parseInt(x.mes))
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.valor.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarUte = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/porcentajeute`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);

            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectRegistro = (anio, mes, valor) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/porcentajeute/vervalorporce?anio=${anio}&mes=${mes}&valor=${valor}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.anio >= 0) {
            setUte(response.data);

            setActivate(false);
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "error al cargar usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const operaciones = (anio, mes, valor, op) => (e) => {
    e.preventDefault();
    setOperacion(op);

    if (op === 4) {
      if (accporcenute.substring(0, 1) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accporcenute.substring(1, 2) !== "0") {
        setMostrar(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accporcenute.substring(2, 3) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accporcenute.substring(3, 4) !== "0") {
        SelectRegistro(anio, mes, valor);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const cerrarModal = () => {
    setMostrar(false);
    setUte("");
  };

  useEffect(() => {
    seleccionarUte();
  }, []);

  return (
    <div className="h-100 w-100 p-0 m-0">
      <div className="container">
        <div className="content">
          <div className="card px-3 py-2">
            <div className="col-md-12 row m-0 py-1">
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
              </div>

              <div className="col-md-1 ml-auto">
                <button
                  onClick={operaciones("", "", "", 1)}
                  className={
                    accporcenute.substring(0, 1) === "0"
                      ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                      : "btn btn-sm mx-1 btn-primary rounded-circle"
                  }
                >
                  <i className="fas fa-plus"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {item.anio}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "start" }}
                        >
                          {cmes(parseInt(item.mes))}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {moment(item.fechaaplic).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "end", width: "200px" }}
                        >
                          {item.valor.replace(".", ",")}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "200px" }}
                        >
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              4
                            )}
                            className={
                              accporcenute.substring(0, 1) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-info rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              2
                            )}
                            className={
                              accporcenute.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={operaciones(
                              item.anio,
                              item.mes,
                              item.valor,
                              3
                            )}
                            className={
                              accporcenute.substring(3, 4) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>

      <ToastsGeneral
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ModalActuUte
        show={mostrar}
        onHideCancela={cerrarModal}
        operacion={operacion}
        ute={ute}
        onHideRenderizar={seleccionarUte}
      />

      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaUTE;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablauteporcentaje.js